import { api } from "./api";

export const GeoApi = {
    geoTinhThanhList: (data) => api.post("/api/geo-tinh-thanh-list", data),
    geoQuanHuyenList: (data) => api.post("/api/geo-quan-huyen-list", data),
    geoPhuongXaList: (data) => api.post("/api/geo-phuong-xa-list", data),
    geoUpdate: (data) => api.post("/api/geo-phuong-xa-update", data)

};
